import { render } from "./WriteBtn.vue?vue&type=template&id=15ad97ee"
import script from "./WriteBtn.vue?vue&type=script&lang=js"
export * from "./WriteBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__